/* eslint-disable react/prop-types */

import React  from 'react';

import { Spinner, Button } from 'react-bootstrap';

import { observer } from 'mobx-react';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import { taskSchema } from '../../schema/schema';

import { FormElement } from '../general/FormElement';
import { StringSelect } from '../general/StringSelect';
import { EnumSelect } from '../general/EnumSelect';
import { NumberInput } from '../general/NumberInput';
import { NullableTextInput } from '../general/TextInput';

import { Validated } from '../validated/Validated';

const unitList = ['each', 'batch', 'kg', 'packet', 'carton'];

function getNext5PM() {
    const now = new Date();
    const target = new Date(now);
    target.setHours(17, 0, 0, 0);

    if (now >= target) {
        target.setDate(target.getDate() + 1);
    }

    return target;
}

const TaskEdit = observer(({ taskStore, api, onError, onClose }) => {
    const [siteMap, setSiteMap] = React.useState(null);
    const [taskValue, setTaskValue] = React.useState({
        task: '',
        quantity: 1,
        unit: unitList[0],
        siteId: null,
        who: '',
        requiredBy: getNext5PM(),
    });
    const [users, setUsers] = React.useState(null);
    const [allValid, setAllValid] = React.useState(false);
    const invalidSet = React.useRef(new Set([]));

    React.useEffect(
        () => {
            Promise.all([
                api.axios.get('/users/sites'),
                api.axios.get('/tasks/sites'),
                api.axios.get('/tasks/users'),
            ]).then(res => {
                const userSiteMap = new Map(res[0].data.sites.map(e => [e.id, e.name]));
                const siteMap = new Map(res[1].data.sites.map(e => [e.id, e.name]));
                setTaskValue(
                    prev => ({
                        ...prev,
                        siteId: res[1]?.data.sites[0]?.id || null
                    })
                );
                setSiteMap({ all: siteMap, user: userSiteMap });
                setUsers(res[2].data.users);
            })
            .catch(err => {
                onError(err);
            });

            return () => {};
        }, []
    );

    const handleInitialValidation = (id, validation) => {
        if (validation.valid) invalidSet.current.delete(id);
        else invalidSet.current.add(id);
        setAllValid(invalidSet.size === 0);
    };

    const handleChange = (id, value, invalid) => {
        if (invalid) invalidSet.current.add(id);
        else invalidSet.current.delete(id);
        setAllValid(invalidSet.current.size === 0);

        console.log(id, value);

        setTaskValue(
            prev => ({
                ...prev,
                [id]: value
            })
        );
    };

    const handleDateChange = value => {
        console.log(value);
        const d = new Date(value);
        d.setHours(17)
        d.setMinutes(0)
        handleChange('requiredBy', d, false);
    };

    const handleSubmit = () => {
        const data = {
            ...taskValue,
            requiredBy: taskValue.requiredBy.getTime(),
        };

        taskStore.createTaskAsync(data)
        .then(onClose)
        .catch(err => {
            onError(err);
        });
    };

    if (taskStore.loading || !siteMap) {
        return <div style={{ textAlign: 'center', gridColumn: '1/-1', marginTop: '2em' }}>
            <span>Loading...<Spinner animation='border' variant='info' size='sm' style={{ marginLeft: '2rem'}}/></span>
        </div>
    }

    return (
        <div style={{ marginTop: '1em', paddingRight: '2em' }} >
            <Validated
                id='task'
                label = 'Task'
                schema = {taskSchema}
                value = {taskValue.task}
                onChange={handleChange}
                onLoad={handleInitialValidation}
                render = { props => <FormElement
                    {...props}
                    render={props => <NullableTextInput {...props} />}
                />}
            />
            <Validated
                id='requiredBy'
                label = 'Required By'
                schema = {taskSchema}
                value = {taskValue.requiredBy}
                onChange={handleDateChange}
                onLoad={handleInitialValidation}
                render = { props => <FormElement
                    {...props}
                    render = { props => <DatePicker
                        {...props}
                        selected={props.value}
                        dateFormat='dd MMM yyyy'
                        todayButton='today'
                    />}
                />}
            />
            <Validated
                id='quantity'
                label = 'Quantity'
                schema = {taskSchema}
                value = {taskValue.quantity}
                onChange={handleChange}
                onLoad={handleInitialValidation}
                render = { props => <FormElement
                    {...props}
                    render = { props => <NumberInput
                        {...props}
                        style={{ width: '12em', marginRight: '0.2em', marginBottom: '0.2em' }}
                    />}
                />}
            />
            <Validated
                id='unit'
                label = 'Unit'
                schema = {taskSchema}
                value = {taskValue.unit}
                onChange={handleChange}
                onLoad={handleInitialValidation}
                render = { props => <FormElement
                    {...props}
                    render={props => <StringSelect {...props} options={unitList} />}
                />}
            />
            <Validated
                id='siteId'
                label = 'Site'
                schema = {taskSchema}
                value = {taskValue.siteId}
                onChange={handleChange}
                onLoad={handleInitialValidation}
                render = { props => <FormElement
                    {...props}
                    render={props => <EnumSelect {...props} optionsMap={siteMap.all} />}
                />}
            />
            <Validated
                id='who'
                label = 'Who'
                schema = {taskSchema}
                value = {taskValue.who}
                onChange={handleChange}
                onLoad={handleInitialValidation}
                render = { props => <FormElement
                    {...props}
                    render={props => <StringSelect {...props} options={users} />}
                />}
            />
            <div style={{ display: 'flex', justifyContent: 'end' }}>
                <Button variant='info' onClick={onClose} className='ms-2'>
                    Cancel & Close
                </Button>
                <Button variant='info' onClick={handleSubmit} className='ms-2' disabled={!allValid}>
                    Add Task
                </Button>
            </div>
        </div>
    );
});

export { TaskEdit }
